import { ArrowLeft, ArrowRight } from "@components/Icons"
import React, { FC } from "react"
import * as S from "./SliderNav.styles"

type SliderNavProps = {
  variant: "prev" | "next"
  handleClick: () => void
}

export const SliderNav: FC<SliderNavProps> = ({ variant, handleClick }) => {
  return (
    <S.Button data-variant={variant} onClick={handleClick}>
      {variant === "prev" ? <ArrowLeft /> : <ArrowRight />}
    </S.Button>
  )
}
